import { render } from "./ModalSpinners.vue?vue&type=template&id=f9589586&scoped=true"
import script from "./ModalSpinners.vue?vue&type=script&lang=js"
export * from "./ModalSpinners.vue?vue&type=script&lang=js"

import "./ModalSpinners.vue?vue&type=style&index=0&id=f9589586&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9589586"]])

export default __exports__